import { render } from "./DetailsHospitalisation.vue?vue&type=template&id=6b326b86&scoped=true"
import script from "./DetailsHospitalisation.vue?vue&type=script&lang=js"
export * from "./DetailsHospitalisation.vue?vue&type=script&lang=js"

import "./DetailsHospitalisation.vue?vue&type=style&index=0&id=6b326b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b326b86"]])

export default __exports__